module.exports = __webpack_public_path__ + "static/media/sampleCohortOverview_mobile.410c64a6.png";